import React, { useState, useEffect } from "react";
import { View, TextInput } from "react-native";

import CloseIcon from "../../common/dialog/CloseIcon";
import {
  getStorageItem,
  getStorageKey,
  setStorageItem,
} from "../../../../helpers/utils.js";
import MoodsList from "../../common/mood/MoodsList";
import ManaButton from "../../common/ManaButton";
import cardStyles from "./cardStyles";
import Goal from "../../resolution/goals/Goal";
import ElementsHelper from "../../elements/ElementsHelper";
import CardUtils from "./CardUtils";

export default function GoalAchievedCard({
  controller,
  data,
  isSnoozed = false,
  showManaMindFul = () => {},
  onSnooze = () => {},
}) {
  const [note, setNote] = useState(data.gem_text || "");
  const [mood, setMood] = useState(data.gem_mood);
  const [showCard, setShowCard] = useState(true);

  const cardUtils = new CardUtils(controller, data, setShowCard);
  useEffect(() => {
    cardUtils.restoreCard(data.stored_data);
  }, []);

  const saveCardData = () => {
    setShowCard(false);
    if (showManaMindFul) showManaMindFul();

    controller.tracking.track("Edit Goal Achieved Gem");
    const action = {
      action: "save",
      target: "gem",
      item_id: data.gem_target_id,
      time_unit: data.gem_time_unit,
      day: data.gem_day,
      item_type: data.gem_type,
      gem_id: data.gem_id,
      hours: data.tracked,
      note: note,
      mood: mood,
    };

    controller.cardAction(action);
  };

  const element = ElementsHelper.findById(controller, data.gem_target_id);

  const goal = {
    target_name: element?.name,
    target_emoji: data.icon,
    hours: data.tracked,
    target_hours: data.target,
    time_unit: data.goal_time_unit,
    total_pct: Math.max(Math.min(Math.abs(data.total_pct), 1), 0),
    target_achieved: 1,
    achieved_pct: 1,
    mood: 5,
    text: "Goal achieved, congratulations!",
  };

  return !isSnoozed && !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card]}>
        <CloseIcon onPress={(e) => onSnooze(cardUtils, e)} style={cardStyles.closeButton} />

        <View style={{ width: "100%" }}>
          <Goal style={cardStyles.goal} controller={controller} goal={goal} />
          <View style={cardStyles.separator} />
          <MoodsList
            selectedMood={mood}
            onSelect={(m) => setMood(m)}
            showTitle
          />
          {mood ? (
            <View>
              <View style={cardStyles.messageContainer}>
                <TextInput
                  name={"goalAchievedNote"}
                  style={cardStyles.input}
                  autoFocus={false}
                  multiline={true}
                  numberOfLines={2}
                  value={note}
                  onChangeText={(text) => setNote(text)}
                  placeholderTextColor="#9C9EB9"
                  placeholder="Enter a quick thought on how achieving this goal makes you feel..."
                />
              </View>

              <View style={cardStyles.buttons}>
                <ManaButton
                  onPress={saveCardData}
                  style={cardStyles.buttonSmall}
                  styleText={cardStyles.buttonSmallText}
                  text="Journal"
                />
              </View>
            </View>
          ) : null}
        </View>
      </View>
    </View>
  );
}
